const BASE_URL: string = '/log-in';

/**
 * 
 */
export const LOGIN_PATH = {

  LOGIN: BASE_URL,
}